<a
  [routerLink]="routeSegments()"
  [routerLinkActiveOptions]="{ exact: isExactRoute() }"
  routerLinkActive=""
  #rla="routerLinkActive"
  class="sm:px-4 sm:py-4 md:px-3 sm:justify-start sm:border sm:border-primary-450 px-3.5 h-12 rounded text-x-small font-bold flex items-center gap-x-1 hover:bg-primary-600 dark:hover:bg-primary-400 sm:dark:border-primary-700 text-text-000 dark:text-text-700"
  [ngClass]="rla.isActive ? ['bg-secondary-500', 'dark:bg-primary-600'] : null"
  [class.pointer-events-none]="!isSideMenuOpen()"
  (click)="onNavigationClick($event)"
>
  @if (iconKey(); as iconKey) {
    <div class="sm:hidden">
      <svg-icon [key]="iconKey" />
    </div>
  }
  @if (isSideMenuOpen()) {
    <span class="sm:text-large">{{ label() }}</span>
  }
</a>
